var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Returns a single string of class names to add to HTML elements.
 *
 * Implementation and tests adapted from https://www.npmjs.com/package/classnames.
 * This helper was built to replace our reliance on this dependency.
 *
 * @param {NestedClassNamesArray} args List of class names to concatenate.
 *
 * @return {string} The concantenated classnames.
 */
export var classNames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    var _loop_1 = function (i) {
        if (args[i]) {
            if (typeof args[i] === 'string' || typeof args[i] === 'number') {
                classes.push(args[i]);
            }
            else if (Array.isArray(args[i])) {
                if (args[i].length) {
                    var inner = classNames.apply(void 0, __spread(args[i]));
                    if (inner) {
                        classes.push(inner);
                    }
                }
                // Using typeof here as typescript doesn't detect the type guard with argType.
            }
            else if (typeof args[i] === 'object') {
                if (args[i].toString !== Object.prototype.toString) {
                    classes.push(args[i].toString());
                }
                else {
                    Object.keys(args[i]).forEach(function (key) {
                        if (args[i][key]) {
                            classes.push(key);
                        }
                    });
                }
            }
        }
    };
    for (var i = 0; i < args.length; i += 1) {
        _loop_1(i);
    }
    return classes.join(' ');
};
//# sourceMappingURL=classNames.js.map